/** @jsxImportSource @emotion/react */
import React from 'react'
import {
  AlignItems,
  Box,
  Display,
  BorderStyle,
  Color,
  Heading3,
  Icon,
  IconVariant,
  JustifyContent,
  Space,
  Text,
  LinkVariant,
  FlexDirection,
} from '@gousto-internal/citrus-react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Property as CSSProperty } from 'csstype'
import { Link } from '../Routing/Link'
import { client } from '../../config/routes'

interface ArticlePreviewProps {
  id: number,
  description: string,
  nameSlug: string,
  name: string,
}

const truncateOnTwoLines = {
  display: '-webkit-box',
  WebkitLineClamp: 2,
  overflow: 'hidden',
  WebkitBoxOrient: 'vertical' as CSSProperty.BoxOrient,
}

const ArticlePreview = ({
  id, description, nameSlug, name,
}: ArticlePreviewProps) => (
  <Link
    display={Display.Block}
    css={{ textDecoration: 'none' }}
    key={id}
    variant={LinkVariant.None}
    href={`/help-centre${client.article}/${nameSlug}/${id}`}
  >
    <Box
      paddingH={5}
      paddingV={5}
      borderColor={Color.ColdGrey_100}
      borderStyle={BorderStyle.Solid}
      borderRadius={1}
      borderWidth={0.5}
      display={Display.Flex}
      justifyContent={JustifyContent.SpaceBetween}
    >
      <Box display={Display.Flex} flexDirection={FlexDirection.Column}>
        <Heading3 color={Color.ColdGrey_800} size={2}>{name}</Heading3>
        <Space size={1} />
        <Text
          color={Color.NeutralGrey_600}
          css={truncateOnTwoLines}
        >
          {description}
        </Text>
      </Box>
      <Space
        direction="vertical"
        size={5}
      />
      <Box display={Display.Flex} alignItems={AlignItems.Center}>
        <Icon name="chevron_right" variant={IconVariant.Actionable} />
      </Box>
    </Box>
  </Link>
)

export { ArticlePreview }
